import { ValidationRuleId } from '@/lib/graphql/generated/graphql';
import { productsState } from '@/states/products.state';
import { atom } from 'jotai';

export const pricingRules = [
  ValidationRuleId.DiscountConsistency,
  ValidationRuleId.PricingMarginConsistency,
] as const;
export type PricingRule = (typeof pricingRules)[number];
export const isPricingRule = (rule: ValidationRuleId): rule is PricingRule =>
  pricingRules.some((candidate) => candidate === rule);

// Persisted verdicts keep a group visible until backend revalidation confirms resolution.
// Include unselected products so correcting prices never silently changes the sale selection.
export const pricingCorrectionGroupsAtom = atom((get) =>
  pricingRules
    .map((ruleId) => {
      const itemIds = get(productsState)
        .filter((product) =>
          product.activeVersion.validationErrors?.some(
            (error) => error.ruleId === ruleId && error.severity === 'error'
          )
        )
        .map(({ id }) => id);
      return { ruleId, itemIds, count: itemIds.length };
    })
    .filter(({ count }) => count > 0)
);

export const pricingCorrectionPendingAtom = atom(false);
